import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const Wrapper = styled.div`
    padding: ${token('space.050')};
    height: fit-content;
    background: ${token('elevation.surface')};
`;
